<template>
  <div class="container-lg clearfix px-2">
    <span v-if="hydrant">
      <form @submit.prevent="logCheck">
        <h4>{{ hydrant.name }}</h4>

        <!-- VEGETATION OVERGROWN -->
        <dt class="form-group">
          <label>
            <input type="checkbox" v-model="theCheck.vegetation_overgrown" />
            vegetation overgrown?
          </label>
        </dt>
        <!-- TANK LOCKED -->
        <dt v-if="isTank()" class="form-group">
          <label>
            <input type="checkbox" v-model="theCheck.tank_locked" />
            tank locked?
          </label>
        </dt>
        <!-- LOCK OPERABLE -->
        <dt v-if="isTank()" class="form-group">
          <label>
            <input type="checkbox" v-model="theCheck.lock_operable" />
            lock operable?
          </label>
        </dt>
        <!-- LINE USED -->
        <dl
          v-if="isTank()"
          class="form-group"
          v-bind:class="{ errored: fieldHasError('lineUsed') }"
        >
          <dt><label for="line_used">hose line used</label></dt>
          <dd>
            <select
              class="form-control"
              ref="lineUsed"
              v-model.trim="theCheck.line_used"
            >
              <option value="">select line used</option>
              <option value="1 1/2">1 1/2</option>
              <option value="1 3/4">1 3/4</option>
              <option value="2 1/2">2 1/2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
            </select>
          </dd>
          <dd class="error" v-if="fieldHasError('lineUsed')">
            please select a hose line size from the list
          </dd>
        </dl>
        <!-- PRIME PULLED -->
        <dt class="form-group">
          <label>
            <input type="checkbox" v-model="theCheck.prime_pulled" />
            prime pulled?
          </label>
        </dt>
        <!-- CIRCULATED -->
        <dt class="form-group">
          <label>
            <input type="checkbox" v-model="theCheck.circulated" />
            circulated?
          </label>
        </dt>
        <!-- MINUTES PUMPED -->
        <dl
          class="form-group"
          v-bind:class="{ errored: fieldHasError('minutesPumped') }"
        >
          <dt><label for="minutes_pumped">Minutes Pumped</label></dt>
          <dd>
            <input
              class="form-control"
              type="phone"
              ref="minutesPumped"
              v-model.number.trim="theCheck.minutes_pumped"
            />
          </dd>
          <dd class="error" v-if="fieldHasError('minutesPumped')">
            please enter a number, greater than 0
          </dd>
        </dl>
        <!-- IN SERVICE -->
        <dt class="form-group">
          <label>
            <input
              type="checkbox"
              v-on:change="checkNotesRequred"
              v-model="theCheck.in_service"
            />
            in service?
          </label>
        </dt>
        <!-- NEEDS FOLLOW UP -->
        <dt class="form-group">
          <label>
            <input
              type="checkbox"
              v-model="theCheck.needs_follow_up"
              v-on:change="checkNotesRequred"
            />
            needs follow up check?
          </label>
        </dt>
        <!-- NOTES -->
        <dl
          class="form-group"
          v-bind:class="{ errored: fieldHasError('notes') }"
        >
          <dt><label for="notes">any notes?</label></dt>
          <dd>
            <textarea
              class="form-control"
              id="notes"
              rows="3"
              v-model="theCheck.notes"
              @input="checkNotesRequred"
            ></textarea>
          </dd>
          <dd class="error" v-if="fieldHasError('notes')">
            note is required to mark a hydrant as out of service or needing a
            follow up.
          </dd>
        </dl>
        <!-- PUMP OPERATOR -->
        <dl
          class="form-group"
          v-bind:class="{ errored: fieldHasError('pumpOperator') }"
        >
          <dt><label for="line_used">pump operator</label></dt>
          <dd>
            <select
              class="form-control"
              ref="pumpOperator"
              v-model.trim="theCheck.pump_operator_id"
            >
              <option value="">select pump operator</option>
              <option
                v-for="pumpOperator in pumpOperators"
                v-bind:key="pumpOperator.id"
                :value="pumpOperator.id"
              >
                {{ pumpOperator.name }}
              </option>
            </select>
          </dd>
          <dd class="error" v-if="fieldHasError('pumpOperator')">
            please select the pump operator who performed the check
          </dd>
        </dl>
        <!-- APPARATUS -->
        <dl
          class="form-group"
          v-bind:class="{ errored: fieldHasError('apparatus') }"
        >
          <dt><label for="apparatus">apparatus</label></dt>
          <dd>
            <select
              class="form-control"
              ref="apparatus"
              v-model.trim="theCheck.apparatus_id"
            >
              <option value="">select apparatus</option>
              <option
                v-for="engine in apparatus"
                v-bind:key="engine.id"
                :value="engine.id"
              >
                {{ engine.name }}
              </option>
            </select>
          </dd>
          <dd class="error" v-if="fieldHasError('apparatus')">
            please select the apparatus used
          </dd>
        </dl>
        <!-- ACTIONS -->
        <div class="form-actions">
          <button type="submit" class="btn btn-block btn-primary">
            record check
          </button>
          <br />
          <router-link
            :to="'/#hydrant-' + hydrant.id"
            class="btn btn-block mt-2"
            >cancel</router-link
          >
        </div>
      </form>
    </span>
    <span v-else-if="!loading">
      <h4>
        Unable to find that hydrant. Please tell FF Sterner if you see this
      </h4>
    </span>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "NewHydrantCheckView",
  components: {},
  props: {
    hydrant_id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      theCheck: this.newCheck(),
      errors: {},
      loading: true
    };
  },
  created() {
    this.$store.dispatch("getEverything");
  },
  computed: {
    hydrant() {
      return this.$store.state.hydrants.find(hydrant => {
        return hydrant.id === this.hydrant_id;
      });
    },
    pumpOperators() {
      return this.$store.state.pumpOperators;
    },
    apparatus() {
      return this.$store.state.apparatus;
    }
  },
  methods: {
    checkNotesRequred() {
      this.$nextTick(() => {
        if (
          (!this.theCheck.in_service || this.theCheck.needs_follow_up) &&
          this.theCheck.notes === ""
        ) {
          this.errors["notes"] = true;
        } else {
          delete this.errors.notes;
        }
        this.$forceUpdate();
      });
    },
    fieldHasError(key) {
      return this.errors[key] != null;
    },
    newCheck() {
      return {
        id: null,
        vegetation_overgrown: false,
        tank_locked: true,
        lock_operable: true,
        prime_pulled: true,
        circulated: true,
        line_used: "",
        minutes_pumped: "",
        in_service: true,
        notes: "",
        pump_operator_id: "",
        apparatus_id: "",
        needs_follow_up: false
      };
    },
    isTank() {
      return this.hydrant.hydrant_type === "tank";
    },
    formIsValid() {
      this.errors = {};
      if(this.theCheck.minutes_pumped === "") {
        this.errors["minutesPumped"] = true;
      }
      if(this.isTank() && this.theCheck.line_used === "") {
        // line used required
        this.errors["lineUsed"] = true;
      }
      if(this.theCheck.pump_operator_id === "") {
        this.errors["pumpOperator"] = true;
      }
      if(this.theCheck.apparatus_id === "") {
        this.errors["apparatus"] = true;
      }

      return Object.keys(this.errors).length === 0
    },
    async logCheck() {
      if(this.formIsValid()) {
        Object.assign(this.theCheck, { hydrant_id: this.hydrant.id });
        await this.$store.dispatch("createHydrantCheck", this.theCheck)

        if(!('error' in this.$store.state.flashV2)) {
          router.replace("/");
        }
      }
    },
    reset() {
      this.newCheck = this.newCheck();
      this.errors = {};
    }
  },
  mounted() {}
};
</script>

<style>
.form-group textarea.form-control {
  min-height: 75px;
  height: 75px;
}
</style>
